import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CandidateDetails } from 'src/app/shared/models/candidate';
import { TopProfile } from 'src/app/shared/models/operations_persona';
import { TableDetails, DonutTabs } from 'src/app/shared/models/duplicateCheckTable';
import { TableWithChip } from 'src/app/shared/models/validateResumeTable';
import { environment } from 'src/environments/environment.prod';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SnackbarComponent } from '../../../shared/components/snackbar/snackbar.component';

import { AzureConfig } from 'src/app/core/models/config';
import { EnvService } from 'src/app/env.service';

@Injectable({
  providedIn: 'root',
})
export class DuplicatecheckService {
  readonly dashboardUrl = environment.dashboardUrl;
  candidateUrl = environment.createCandidateUrl;
  readonly profileUrl = environment.profileUrl;
  readonly validationUrl = environment.validationUrl;
  unitData: any[];
  getCandidateUrl: string = environment.parserUrl + 'deduplicateCheck/';
  blobApi: string = this.envService.bloburl + '/json/AcknowledgementActivity.json';
  panelistUrl: string = environment.recruiterPanelistUrl;
  rehireUrl: string = environment.rehireUrl;
  blobDetails: AzureConfig = <AzureConfig>{};

  constructor(
    private httpClient: HttpClient,
    private snackBar: MatSnackBar,
    private envService: EnvService,
  ) {}

  getCandidateCheckDetails(body): Observable<any[]> {
    //  return this.httpClient.get<any[]>("assets/json/getCandidateCheckDetails.json");
    return this.httpClient.post<any[]>(this.getCandidateUrl, body);
  }

  getExInfoCheck(empNo) {
    const panelUrl = this.panelistUrl.substring(0, this.panelistUrl.lastIndexOf('/'));
    return this.httpClient.get(panelUrl + '/exInfoscianCheck?empNo=' + empNo);
  }

  getEmpRehireCheck(empNo) {
    return this.httpClient.get(this.rehireUrl + 'ExtenalServices/v1/GetEmpDetailsForInTap/' + empNo);
  }

  getCandidateDetails(): Observable<CandidateDetails[]> {
    const _params = new HttpParams().set('applicationIds', '1001,1001,1001,1001');
    return this.httpClient.get<CandidateDetails[]>('assets/json/candidatedetails2.json');
  }

  getOriginalData(): Observable<CandidateDetails[]> {
    return this.httpClient.get<CandidateDetails[]>('assets/json/duplicateCheck.json');
  }

  getExInfoscionDetails(body) {
    return this.httpClient.post(this.profileUrl + 'profileService/exInfoscianService', body);
  }

  getSeekClarification(body): Observable<any> {
    return this.httpClient.post<any>(this.validationUrl + 'dbadmin/seekClarification', body);
  }

  saveClarificationStatusChange(id, type): Observable<any> {
    return this.httpClient.post<any>(
      this.profileUrl + 'profileService/pendingclarificationStatus?objectId=' + id + '&objectType=' + type,
      null,
    );
  }

  getClarificationTemplates() {
    return this.httpClient.get<any[]>('assets/cdn/json/getClarificationTemplates.json');
  }

  openSnackBar(message: object, panelClass: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: 2000,
    });
  }

  getProfileData(): Observable<TopProfile[]> {
    return this.httpClient.get<TopProfile[]>('assets/json/topprofile.json');
  }

  getValidateReumeTableDetails(): Observable<TableWithChip[]> {
    return this.httpClient.get<TableWithChip[]>('assets/json/validateResumeTableDetails.json');
  }

  getDuplicateCheckTableDetails(): Observable<TableDetails[]> {
    return this.httpClient.get<TableDetails[]>('assets/json/duplicateCheckTableDetails.json');
  }

  getDonutTabsDetails(body: any): Observable<DonutTabs[]> {
    return this.httpClient.post<DonutTabs[]>(
      this.dashboardUrl + 'DashboardServicesForValidateAndDuplicate/getNumberOfCandidateByUnit',
      body,
    );
  }

  getDuplicateCheckTableData(data): Observable<any[]> {
    return this.httpClient.post<any[]>(
      this.dashboardUrl + 'DashboardServicesForValidateAndDuplicate/getNumberOfCandidateByUnit',
      data,
    );
  }

  getDonutDatabySource(data, value): Observable<any[]> {
    if (value == 'Source') {
      return this.httpClient.post<any[]>(
        this.dashboardUrl + 'DashboardServicesForValidateAndDuplicate/getNumberOfCandidateBySources',
        data,
      );
    } else if (value == 'Location') {
      return this.httpClient.post<any[]>(
        this.dashboardUrl + 'DashboardServicesForValidateAndDuplicate/getNumberOfCandidateByLocation',
        data,
      );
    }
  }

  CreateCandidate(body): Observable<any> {
    return this.httpClient.post<any>(this.candidateUrl + 'submitCandidate/CreateCandidate', body);
  }

  AssignapplicationId(body): Observable<any> {
    return this.httpClient.post<any>(this.candidateUrl + 'submitCandidate/CreateCandidate', body);
  }

  getJobDescriptionDetails(referenceCode): Observable<any> {
    return this.httpClient.get<any>(this.candidateUrl + 'v1/getPublicationDetails?referenceCode=' + referenceCode);
  }

  getDonut(body) {
    this.getDuplicateCheckTableData(body).subscribe((data) => {
      this.unitData = data;
    });
  }

  getAcknoledgementJson() {
    // return this.httpClient.get<any>(this.blobApi);
    return this.httpClient.get<any>('/assets/json/AcknowledgementActivity.json');
  }

  statusChange(objectId, status) {
    // objectId=23025
    return this.httpClient.post(
      this.profileUrl + 'profileService/statusChange/' + objectId + '?objectType=AP&status=' + status,
      {},
    );
  }
}
